import { Component, ElementRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
// import {Control} from '@angular/common';
import {FormControl, FormGroup} from '@angular/forms';
// import {TRANSLATE_PROVIDERS, TranslateService, TranslatePipe, TranslateLoader, TranslateStaticLoader} from 'ng2-translate/ng2-translate';

import {LocationService} from './locationsearch.service';
import {EventsService} from '../shared/Events.service';
import { SettingsService } from '../shared/settings/settings.service';

import {TranslateService} from 'ng2-translate/ng2-translate';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';


@Component({ 
    selector: 'location-search',
    //templateUrl: 'app/location-search/locationsearch.component.html',
    template: require('../location-search/locationsearch.component.html'),
    styles: 
    [
        'li:hover { background-color: #ED1C24; }',
        'li:hover > span {color:lightgray }',
        'li {cursor:pointer}',
        'li {cursor:pointer; border: lightgray 1px solid; min-height: 36px; }',
        'ul {background-color: white; padding: 0px 0px 0px 0px; z-index:100}',
        // '#searchContainer {width:325px}',
        // '.mdl-textfield__input { width:250px}',
        // '.mdl-textfield__label { padding-left: 10px; color: #CCCCCC;}',
        '@-moz-document url-prefix() { .locationSearchIcon {margin-top:-50px;}}',
        '*::-ms-backdrop, .locationSearchIcon {margin-top:-50px !important;}'
    ],
    // styles: [require('../location-search/locationsearch.component.css')],
    providers: [LocationService]
    //    pipes: [TranslatePipe]
})
export class LocationSearchComponent {
    @ViewChild('searchinput') searchinput: ElementRef;
    @ViewChild('lstSuggestions') lstSuggestions: ElementRef;
    @ViewChild('searchContainer') searchContainer: ElementRef;
    @Output() selectedAddressItem = new EventEmitter<Object>();
    @Output() voterAddressValid = new EventEmitter<boolean>();
    @Input() inputWidth: string = "";
    @Input() inputAddress: string = "";
    @Input() inputCity: string = "";
    @Input() inputZip: string = "";
    @Input() inputXcoord: string = "";
    @Input() inputYcoord: string = "";
    
    public typedAddress:string;
    public suggestions:Array<Object>;
    values='';
    error: any;
    pickedAddress: any;
    searchInProgress: boolean = false;
    term = new FormControl();
    // lstSuggestions = new FormControl();
    ignoreTextChange: boolean = false;
    placeHolderText:String ;
    enableFallback: boolean = false;
    items: Observable<Array<Object>>;
    fallbackRun:boolean = false;
    dialogShow:boolean = false;

    searchButtonEnabled:boolean = true;

    langValue:string = "en";
    
    validRangesHeader:string = "";
    oneSuggStreet:boolean = false;
    validStreetRanges:Array<Object>;

    selectIdx:number = -1;


    constructor(private elRef: ElementRef, private locationService: LocationService, private _eventsService: EventsService,private translate: TranslateService) {

    }

    ngOnInit() {
        // create the map
        //this._mapService.createMap(this.itemId, this.elRef.nativeElement.firstChild, this.options).then((response) => {
        //  // get a reference to teh map and expose response to app
        //  this.map = response.map;
        //  this.mapLoaded.next(response);
        //});
        
        // this.translate.get('addressPlaceholder').subscribe((res: string) => {
        //     // do something with res
        //     this.placeHolderText = res;

        // });
 
        // this.translate.get('addressSearchInstructions').subscribe((res: string) => {
        //     // do something with res
        //     this.placeHolderText = res;

        // });

        this._eventsService.languageChanged$.subscribe(language => {
            this.langValue = language;
        });

        this._eventsService.startAddressFromGeolocation$.subscribe(() => {
            this.searchInProgress = true;
        });

        this._eventsService.addressFromGeolocation$.subscribe(addressLocation => {
            this.searchInProgress = false;
            if(addressLocation == null){
                return;
            }
            if(addressLocation["address"].Street){
                this.inputAddress = addressLocation["address"].Street;
            }
            if(addressLocation["address"].City){
                this.inputCity = addressLocation["address"].City;
            }
            if(addressLocation["address"].ZIP){
                this.inputZip = addressLocation["address"].ZIP;
            }
            if(addressLocation["location"].x && addressLocation["location"].y){
                let selectCoords:object = {
                    Xcoord: addressLocation["location"].x,
                    Ycoord: addressLocation["location"].y
                };
                this.inputXcoord = selectCoords["Xcoord"];
                this.inputYcoord = selectCoords["Ycoord"];
            }
            this.setAddressFromOutsideSourceIfAvailable();
        });

    
        this.term.valueChanges
            .debounceTime(400)
            // .distinctUntilChanged()
            .switchMap(term => this.turnOnInProgress(term))
            .subscribe(suggestions => {

                this.suggestionsReceived(suggestions)
            }, 
            err => this.handleError(err));
                                    
        this.locationService.navItem$.subscribe(item => 
            item ? this.searchInProgress = true : this.searchInProgress = false
        );
    }

    ngAfterViewInit(){
        this.setAddressFromOutsideSourceIfAvailable();
    }

    setAddressFromOutsideSourceIfAvailable(){
        console.log("set location if needed");
        if(this.inputAddress != "" && (this.inputXcoord == "" || this.inputYcoord == "")){
            this.searchinput.nativeElement.focus();
            this.searchinput.nativeElement.value = this.inputAddress;
            this.term.setValue(this.inputAddress);
            this.searchContainer.nativeElement.classList.remove('is-invalid');
            this.searchContainer.nativeElement.classList.add('is-focused');
            this.searchContainer.nativeElement.classList.add('is-dirty');
            this.inputAddress = "";
            this.inputCity = "";
            this.inputZip = "";
        }else if(this.inputAddress != "" && this.inputXcoord != "" && this.inputYcoord != "" && Number(this.inputXcoord) != NaN && Number(this.inputYcoord) != NaN){
            this.searchContainer.nativeElement.classList.remove('is-invalid');
            this.searchContainer.nativeElement.classList.add('is-focused');
            this.searchContainer.nativeElement.classList.add('is-dirty');
            this.ignoreTextChange = true;
            this.searchinput.nativeElement.value = this.inputAddress;
            this.term.setValue(this.inputAddress);
            this.pickedAddress = new Object();
            this.pickedAddress["FullName"] = this.inputAddress;
            this.pickedAddress["City"] = this.inputCity;
            this.pickedAddress["FullAddress"] = this.inputAddress + ", " + this.inputCity;
            this.pickedAddress["Zip"] = this.inputZip;
            this.pickedAddress["HouseNum"] = this.inputAddress.split(" ")[0];
            this.addressLocationPicked([{"X":Number(this.inputXcoord), "Y":Number(this.inputYcoord)}]);
            this.inputAddress = "";
            this.inputCity = "";
            this.inputZip = "";
            this.inputXcoord = "";
            this.inputYcoord = "";
        }
    }

    private turnOnInProgress(term:string){
        if (this.ignoreTextChange == false){
            this.searchInProgress = true;
            return this.locationService.getAddressSuggestions(term);
        }else{
            return [];   
        }
    }
    
    emptySuggestionsFallback(){
        if (this.enableFallback == true){
            this.locationService.searchType = "Streets";
            this.fallbackRun = true;
            this.term.setValue(this.searchinput.nativeElement.value);
            this.enableFallback = false;
        }else{
            return;
        }
    }

    public handleError(error: any) {
        console.log(error);
        this.suggestions = [];
        this.searchInProgress = false;
        //return Observable.throw(error.json().error || 'Server error');
    }

    // destroy map
    ngOnDestroy() {

    }       
    
    //invoke fallback search if criteira met
    public startFallbackSearch() {
            this.enableFallback = true;
            this.term.setValue(this.searchinput.nativeElement.value);
    }

    onKey(event:any) {
        this.ignoreTextChange = false;
        if(this.searchinput.nativeElement.value == ""){
            this.suggestions = [];
            this.searchInProgress = false;
            // this._eventsService.voterAddressValid(false);

            //diable the search button and reset label
            this.searchButtonEnabled = true;
            //// this.placeHolderText = "Type to enter address"

            this.voterAddressValid.emit(false)
        }

        if(event.keyCode == 13){
            this.enableFallback = true;
            this.term.setValue(this.searchinput.nativeElement.value);
        } else if (event.keyCode == 38) {

            // this.lstSuggestions.nativeElement.children[0].focus()
        } else if (event.keyCode == 40) {
            this.selectIdx = this.selectIdx + 1;

            // this.lstSuggestions.nativeElement.children[0].focus()
        }else{
            this.fallbackRun = false;
        }

    }

    onKeyDown(event:any){
        this.fallbackRun = false;
    }
    
    
    suggestionsReceived(suggestions){
        this.searchInProgress = false;
        this.suggestions = [];
        if (suggestions.length == 0){

            //enable the search button and chnage the label text
            this.searchButtonEnabled = false;

            //// this.placeHolderText = "Press arrow icon or Enter key to search"

            //             if(this.enableFallback == true){
            //     this.emptySuggestionsFallback();
            // }else if(this.fallbackRun == true){
            //     this.findStreetRanges();
            //     this.locationService.searchType = "";
            //     this.fallbackRun = false;
            // }
            // this.enableFallback = false;
            // return;

                    // this.enableFallback = true;
            //  this.term.setValue(this.searchinput.nativeElement.value);

            if(this.enableFallback == true){
                this.emptySuggestionsFallback();
            }else if(this.fallbackRun == true){
                this.findStreetRanges();
                this.locationService.searchType = "";
                this.fallbackRun = false;

                this.enableFallback = false;

            }
            this.enableFallback = false;
            return;

        }else{
            this.enableFallback = false;
        }
        suggestions.sort((n1,n2) => {
            if (n1["Level"] > n2["Level"]) {
                return -1;
            }
            if (n1["Level"] < n2["Level"]) {
                return 1;
            }
            return 0;
        });
        for (var suggestion of suggestions) {
            if (this.weedoutDuplicateSuggestions(suggestion) == false){
                suggestion = this.constructFullAddress(suggestion);
                this.suggestions.push(suggestion);
            }
        }
        this.suggestions.sort((n1,n2) => {
            if (n1["FullAddress"] > n2["FullAddress"]) {
                return 1;
            }
            if (n1["FullAddress"] < n2["FullAddress"]) {
                return -1;
            }
            return 0;
        });
        this.locationService.searchType = "";
    }


    private constructFullAddress(suggestion:Object){
        if(suggestion["SuggestionType"] == "Streets"){
            var num = this.locationService.parsedAddress["streetNumber"];
            var zip;
            var city;
            if(suggestion["FromLeft"] % 2 ==num % 2 && suggestion["FromLeft"] <= num && suggestion["FromLeft"] >= num){
                city = suggestion["LeftCity"];
                zip = suggestion["LeftZip"];
            }else{
                city = suggestion["RightCity"];
                zip = suggestion["RightZip"];
            }
            suggestion["FullAddress"] = num + " " + suggestion["FullName"] + ", " + city;
            suggestion["StreetNumber"] = num;
            suggestion["FullName"] = num + " " + suggestion["FullName"];
            suggestion["Zip"] = zip;
            suggestion["City"] = city;
        }else if(suggestion["SuggestionType"] == "Address"){
            if(suggestion["Unit"]){
                suggestion["FullAddress"] = suggestion["FullName"] + (suggestion["Unit"] == "" ? "" : " #" + suggestion["Unit"]) + ", " + suggestion["City"];
            }else{
                suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
            }
            suggestion["StreetNumber"] = suggestion["HouseNum"];
        }else{
            suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
        }
        return suggestion;
    }
    
    
    private weedoutDuplicateSuggestions(suggestion:Object):boolean{
        for (var sug of this.suggestions){
            if (sug["FullName"] + " #" + sug["Unit"] == suggestion["FullName"] + " #" + suggestion["Unit"]) {
                return true;
            }
        }
        return false;
    }
    
    findStreetRanges(){
        this.locationService
            .getStreetRanges()
            .then(addressRanges => 
                this.processStreetRanges(addressRanges))
            .catch(error => this.error = error); // TODO: Display error message
    }

    processStreetRanges(addressRanges){
        //Create some variables
        var ranges=new Array();
        var rangesObjArray = new Array();
        //Flag if this is only one street
        var _suggStreets = new Array();
        for(var street of addressRanges){
            //Get street & address ranges
            var stname = street.FullName;
            var lf = street.FromLeft;
            var lt = street.ToLeft;
            var rf = street.FromRight;
            var rt = street.ToRight;
            var min = Math.min(lf, lt, rf, rt);
            var max = Math.max(lf, lt, rf, rt);
        
            //See if this street already is in my list
            var range = null;
            for (var zz=0; zz < ranges.length; zz++)
            {
                if (ranges[zz].name == stname)
                {
                    range=ranges[zz];
                    break;
                }
            }
            //Add range
            if (range == null)
            {
                //Create new street and add it to the list
                range={name: stname, min: min, max: max};
                ranges.push(range);
                _suggStreets.push(stname);
            }
            else
            {
                //Update street range
                if (min < range.min)
                {
                    range.min=min;
                }
                if (max > range.max)
                {
                    range.max=max;
                }
            }
        
            //**Get the min max objects**///
            rangesObjArray.push({"name":stname, "min":min, "max":max});
        }
        if(_suggStreets.length == 1){
            //var sortedRanges = rangesObjArray.sortOn("min", Array.NUMERIC);
            var sortedRanges = rangesObjArray.sort(function (obj1, obj2) {
                return obj1.min - obj2.min;
            });
            var finalRanges = [{"name": sortedRanges[0].name, "min": sortedRanges[0].min, "max": sortedRanges[0].max}];
            for (var sr = 1; sr < sortedRanges.length; sr++){
                if(sortedRanges[sr].min - sortedRanges[sr - 1].max > 99){
                    finalRanges.push(sortedRanges[sr])
                }else{
                    finalRanges[(finalRanges.length - 1)]["max"] = sortedRanges[sr].max;
                }
            }
            ranges = finalRanges;
            this.validRangesHeader = "Valid address ranges for " + sortedRanges[0].name + " are:";
            this.oneSuggStreet = true;
        }else{
            this.oneSuggStreet = false;
            this.validRangesHeader = "Valid address ranges are:";
        }
        if(addressRanges.length == 0){
            this.validRangesHeader = "The address you entered could not be found within Marion County.";
        }
        console.log(ranges);
        this.validStreetRanges = ranges;
        this.dialogShow = true;
        this.searchinput.nativeElement.blur();
    }

    suggestionClicked(suggestion){
        this.searchInProgress = true;
        this.pickedAddress = suggestion;
        this.locationService
            .getAddressLocation(suggestion)
            .then(addressLocation => 
                this.addressLocationPicked(addressLocation))
            .catch(error => this.error = error); // TODO: Display error message
    }
    
    addressLocationPicked(addressLocation){
        this.ignoreTextChange = true;
        this.searchInProgress = false;
        var pickedAddressLocation:Object = {addressSuggestion: this.pickedAddress, addressLocation: addressLocation[0]};
        // this._eventsService.setSelectedAddress(pickedAddressLocation);
        this.selectedAddressItem.emit(pickedAddressLocation);
        this.voterAddressValid.emit(true);

        this.searchinput.nativeElement.value = this.pickedAddress["FullName"];
        this.suggestions = new Array<Object>();
    }
    
    tableRowClick(event:any) {
        alert("row click");
    }
}


// WEBPACK FOOTER //
// ./app/location-search/locationsearch.component.ts